import React from "react";
import menu from "../../../../assets/img/topbar/menu.png";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Avatar from "react-avatar";

export const AdminTopBar = ({ toggleSidebar }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate(); // Initialize the navigate function

  const handleLogout = () => {
    logout(); // Call the logout function
    navigate("/login"); // Redirect to the login or home page
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg yuva-navbar">
        <div className="row w-100 g-1">
          <div className="col-lg-9 col-md-9 col-sm-9 col-6 justify-content-center align-self-center">
            <div className="yuvatopbar-burgertxt">
              <Link
                onClick={() => {
                  if (typeof toggleSidebar === "function") {
                    toggleSidebar();
                  } else {
                  }
                }}
                className="sidebar-toggle"
                id="toggleButton"
              >
                <img src={menu} alt="" />
              </Link>

              <p className="welcome text-white mb-0">
                Welcome,{" "}
                <span className="fw-bold">{user?.user?.firstName}</span>
              </p>
            </div>
          </div>

          <div className="col-lg-3 col-md-3 col-sm-3 col-6 justify-content-end align-self-center d-flex">
            <div className="topbar-profile">
              <div className="btn-group justify-content-center align-self-center">
                <div
                  type="button"
                  className="dropdown-toggle mb-0"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {/* <span className="topbar-username">{user.user.firstName}</span> */}

                  <Avatar
                    name={user?.user?.firstName}
                    color="#667085"
                    round="20px"
                    size="35"
                  />
                </div>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <Link className="dropdown-item" to="/admin/settings">
                      Profile
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>

                  <li>
                    <Link className="dropdown-item" onClick={handleLogout}>
                      Logout
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
